import React from "react";
import { createPortal } from "react-dom";
import Spinner from "./Spinner.jsx";
import CoinAmount from "./CoinAmount.jsx";

export default function ItemHoverWindow({
  visible,
  rect,
  item,
  imageSrc,
  isImageLoading,
  accentColor = "#234",
  buyPrice,
  sellPrice,
}) {
  if (!visible || !rect || !item) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        left: rect.right + 8,
        top: rect.top,
        zIndex: 1100,
        background: "rgba(20, 30, 50, 0.98)",
        border: "2px solid #234",
        borderRadius: 10,
        boxShadow: "0 4px 16px #001a",
        padding: 14,
        minWidth: imageSrc ? 180 : 140,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: imageSrc ? 8 : 0,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          fontSize: 16,
          marginBottom: imageSrc ? 4 : 0,
          color: "#cbe8ff",
          textShadow: "0 1px 4px #001a",
        }}
      >
        {item.name}
      </div>

      {imageSrc && (
        <img
          src={imageSrc}
          alt={item.name}
          style={{
            width: 140,
            height: 140,
            objectFit: "contain",
            borderRadius: 8,
            border: `2px solid ${accentColor}`,
            background: "#182040",
          }}
        />
      )}

      {!imageSrc && isImageLoading && (
        <div
          style={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "#cbe8ff",
            fontSize: 13,
          }}
        >
          <Spinner />
          <div style={{ marginTop: 4, opacity: 0.9 }}>Loading image</div>
        </div>
      )}

      <div style={{ width: "100%", marginTop: 4, display: "grid", gap: 4 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#9be7ff", fontSize: 13 }}>
          <span>Buy</span>
          <CoinAmount value={buyPrice} compact color="#dff5ff" />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#9be7ff", fontSize: 13 }}>
          <span>Sell</span>
          <CoinAmount value={sellPrice} compact color="#dff5ff" />
        </div>
      </div>
    </div>,
    document.body,
  );
}
